import axios, { AxiosInstance } from 'axios';
import * as API from '../../../constants/API';
import { LifeCheckRecord } from '../../../constants/Records';

export class LifeCheckApiClient {
  private api: AxiosInstance;

  static async ClientFactory(): Promise<LifeCheckApiClient> {
    return new LifeCheckApiClient();
  }

  constructor() {
    const apiKey = process.env.REACT_APP_LIFECHECK_API_KEY || '';

    this.api = axios.create({
      baseURL: API.lifecheckApiRoot,
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey,
      },
    });
  }

  // レコード一覧取得
  async getRecords(uniqueId: string): Promise<LifeCheckRecord[]> {
    const res = await this.api.get(`/lifecheck/records/${uniqueId}`);
    return res.data;
  }

  // 特定レコード取得
  async getRecord(uniqueId: string, sequence: number): Promise<LifeCheckRecord> {
    const res = await this.api.get(`/lifecheck/records/${uniqueId}/sequence/${sequence}`);
    return res.data;
  }

  // 最新レコード取得
  async getLatestRecord(uniqueId: string): Promise<LifeCheckRecord> {
    const res = await this.api.get(`/lifecheck/records/${uniqueId}/latest`);
    return res.data;
  }

  // 期間指定取得
  async getRecordsByDateRange(uniqueId: string, from: string, to: string): Promise<LifeCheckRecord[]> {
    const res = await this.api.get(`/lifecheck/records/${uniqueId}/from/${from}/to/${to}`);
    return res.data;
  }

  // レコード作成
  async createRecord(uniqueId: string, data: Partial<LifeCheckRecord>): Promise<LifeCheckRecord> {
    const res = await this.api.post(`/lifecheck/records/${uniqueId}`, data);
    return res.data;
  }

  // レコード更新
  async updateRecord(uniqueId: string, sequence: number, data: Partial<LifeCheckRecord>): Promise<LifeCheckRecord> {
    const res = await this.api.put(`/lifecheck/records/${uniqueId}/sequence/${sequence}`, data);
    return res.data;
  }

  // レコード削除
  async deleteRecord(uniqueId: string, sequence: number): Promise<void> {
    await this.api.delete(`/lifecheck/records/${uniqueId}/sequence/${sequence}`);
  }
}
